import { message } from "antd";
import * as api from "../../api/index";
import { FETCHUSER, UPDATEUSER } from "../constants/userContants";

export const getCurrentUser = (id) => async (dispatch) => {
  try {
    const { data } = await api.getUser(id);
    dispatch({ type: FETCHUSER, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateUser = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.updateUser(id, formData);
    dispatch({ type: UPDATEUSER, payload: data });
    if (data?._id) {
      message.success("User updated successfully");
    }
  } catch (error) {
    if (error) {
      console.log(error);
      message.error(error?.response?.data);
    }
  }
};
